<template>
    <section class="our-stars section" data-sectionThemeDark="false">
        <div class="people">
            <div class="profile"
                v-for="OurStar in sortedArrayByName"
                v-bind:key="OurStar.id" 
                v-show="OurStar.active"
            >
                <img v-bind:src="require('../../assets/imgs/global-stars/' + OurStar.image)" />
                <!-- Dynamically bind the height of the name p tag -->
                <p :style="{ height: equalHeight ? longestNameHeight + 'px' : 'auto', color: 'blue' }">
                    {{ OurStar.name }} 
                </p>
                <p>{{ OurStar.number }}</p>
            </div>
        </div>
        <!--<div class="scroller--element">
            <scroller v-bind="ScrollerConfig" />
        </div>-->
        <SocialIconsMobile v-bind="SocialIconsConfig" />
    </section>
</template>

<script>
import Scroller from '@/components/ui/Scroller'
import SocialIconsMobile from '@/components/ui/SocialIconsMobile'

export default {
    name: "OurStars",
    components: { Scroller, SocialIconsMobile },
    props: ["OurStarsList"],
    data() {
        return {
            ScrollerConfig: {
                color: '#c6c6c6',
                animated: true,
                activeState: true,
                scrollTxt: true,
                hideOnMobile: false
            },
            SocialIconsConfig: {
                DarkIconsTrue: true
            },
            equalHeight: false,   // Flag to trigger applying equal height
            longestNameHeight: 0, // The maximum height of a name <p> tag
        };
    },
    computed: {
        sortedArray: function() {
            function compare(a, b) {
                if (a.sortOrder < b.sortOrder)
                    return -1;
                if (a.sortOrder > b.sortOrder)
                    return 1;
                return 0;
            }
            return [...this.OurStarsList].sort(compare);
        },
        sortedArrayByName: function() {
            function compare(a, b) {
                if (a.name < b.name)
                    return -1;
                if (a.name > b.name)
                    return 1;
                return 0;
            }
            return [...this.OurStarsList].sort(compare);
        }
    },
    mounted() {
        this.setEqualHeight(); // Adjust heights when the component is mounted
    },
    methods: {
        setEqualHeight() {
            this.$nextTick(() => {
                const nameElements = this.$el.querySelectorAll('.profile p');  // Select all name <p> tags
                let maxHeight = 0;
                
                // Calculate the maximum height of the name <p> tags
                nameElements.forEach((el) => {
                    const height = el.offsetHeight;
                    if (height > maxHeight) {
                        maxHeight = height;
                    }
                });

                // Set the equal height for all name <p> tags
                this.longestNameHeight = maxHeight;
                this.equalHeight = true;
            });
        },
    }
}
</script>

<style scoped>
/* Your existing styles remain here */
</style>
